var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 35H28V22.7517C28 19.3917 26.5178 17.5171 23.8595 17.5171C20.9668 17.5171 19.25 19.4705 19.25 22.7517V35H12.25V12.25H19.25V14.8083C19.25 14.8083 21.4462 10.9546 26.3952 10.9546C31.346 10.9546 35 13.9757 35 20.2267V35ZM4.2735 8.61157C1.91275 8.61157 0 6.68318 0 4.30493C0 1.92843 1.91275 0 4.2735 0C6.6325 0 8.54524 1.92843 8.54524 4.30493C8.54699 6.68318 6.6325 8.61157 4.2735 8.61157ZM0 35H8.75V12.25H0V35Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b9cbd47d409302ec65c4c2da9e2a71b8.svg";
export { ForwardRef as ReactComponent };